import { Box, Icon, Link } from "@/components/atoms";
import { FC, memo, useCallback } from "react";
import { FilterAction, OrderCard } from "@/components/molecules";

import { DashboardCustomerProps } from "./DashboardCustomer.interface"
import { HelpModal } from "@/components/organisms/Modais/HelpModal";
import { NATURAL } from "@/theme";
import { useModal } from "@/hooks";

import "./dash.css";

// AKA CustomerOrderList

const DashboardCustomer: FC<DashboardCustomerProps> = ({
    firstName,
    lastName,
    loading, numberOfFilters, onCreateNewOrder, onOpenFilter, onSelectOrder, orders
}) => {
    const { showModal: showHelpModal, onCloseModal: onCloseHelpModal, onOpenModal: onOpenHelpModal } = useModal();

    const url = "https://share.getcloudapp.com/OAuoAj50";
    const embedUrl = `${url}?embed=true&amp;title=true`;

  const handleHelpClick = useCallback((e) => {
    e.stopPropagation();
    onOpenHelpModal();
  }, []);

    return (
        <>
            <h1>Welcome, {firstName} {lastName}</h1>
            <div className="new-order-container">
                <img src="neworder.jpg" alt="New Order" className="action-new" onClick={() => onCreateNewOrder()} />
                <img src="imagemotionvideo.jpg" alt="Imagemotion Video" className="action-new" onClick={() => onCreateNewOrder(11166)} />
                <img src="floorplan.jpg" alt="Floor Plan" className="action-new" onClick={() => onCreateNewOrder(10469)}  />
                <img src="virtualstaging.jpg" alt="Virtual Staging" className="action-new" onClick={() => onCreateNewOrder(10470)}  />
                
                <Box>
                    <Icon type="question" fillColor={NATURAL.K} display="inline-block"/>
                    <Link underline={true} onClick={handleHelpClick}>Click here for video guide</Link>
                </Box>
            </div>
            
            <FilterAction numberOfFilters={numberOfFilters} onOpen={onOpenFilter} />
            {loading ? (
                <div>Loading</div>
            ) : orders.map((order) => {
                return (
                <OrderCard {...order} key={order.id} onClick={() => onSelectOrder(order.id)} />
                );
            })}
            {showHelpModal && (
            <HelpModal
                onClose={onCloseHelpModal}
                url={url}
                embedUrl={embedUrl}
            />
            )}
        </>
    )
}

export default memo(DashboardCustomer);